import type { PartnerBankcardItem } from '@/services/partner/bankcard';
import { defineStore } from 'pinia';

export interface BankcardState {
  selectedBankcard: null | PartnerBankcardItem;
  selectedFundprovidedCard: number;
}

export const useBankcardStore = defineStore('partner-bankcard', {
  state: (): BankcardState => ({
    selectedBankcard: null,
    selectedFundprovidedCard: 1,
  }),
  actions: {
    saveSelectedBankcard(payload: PartnerBankcardItem) {
      this.selectedBankcard = payload;
    },
    resetSelectedBankcard() {
      this.selectedBankcard = null;
    },
    saveSelectedFundprovidedCard(payload: number) {
      this.selectedFundprovidedCard = payload;
    },
    restSelectedFundprovidedCard() {
      this.selectedFundprovidedCard = 1;
    },
  },
  persist: true,
});
